import keycloak from './keycloak';
import type { UserRole } from './types';

export { UserRole } from './types';

export const checkIfRoleIsIncluded = (role: UserRole): boolean => {
  if (process.env.NODE_ENV !== 'production') {
    // Not a FeatureFlag: importing hooks/useFeatureFlag here would be circular.
    const params = new URLSearchParams(window.location.search);
    const disabledRoles = params.get('disableRoles')?.split(',') ?? [];
    if (disabledRoles.includes(role)) return false;
  }
  return keycloak.tokenParsed?.realm_access?.roles.includes(role) ?? false;
};
